import React from "react";
import { NavLink } from "react-router-dom";

const SoccerHeader = () => {
  return (
    <div>
      <ul className="nav justify-content-center card-bottom-border">
        <li className="nav-item mr-3">
          <NavLink
            exact
            to="/"
            className="nav-link  font-weight-bold "
            activeClassName="navlinkcolor-in"
          >
            Home
          </NavLink>
        </li>
        <li className="nav-item mr-3">
          <NavLink
            to="/soccer-live"
            className="nav-link font-weight-bold "
            activeClassName="navlinkcolor-in"
          >
            Right Now
          </NavLink>
        </li>
        <li className="nav-item mr-3">
          <NavLink
            to="/soccer-all-matches"
            className="nav-link  font-weight-bold "
            activeClassName="navlinkcolor-in"
          >
            All Matches Now
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default SoccerHeader;
